import React from "react";
import { useTranslation } from "react-i18next";
import Icon from "../../../../common/components/Icon/Icon";

interface PasswordRequirementsProps {
  password?: string;
  isVisible: boolean;
}

const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({
  password = "",
  isVisible,
}) => {
  const { t } = useTranslation();

  if (!isVisible) return null;

  const hasMinLength = password.length >= 8;
  const hasUppercase = /[A-Z]/.test(password);
  const hasNumber = /[0-9]/.test(password);

  const reqs = [
    {
      label: t("user.passwordRequirements.minLength", "At least 8 characters"),
      met: hasMinLength,
    },
    {
      label: t(
        "user.passwordRequirements.uppercase",
        "At least one uppercase letter"
      ),
      met: hasUppercase,
    },
    {
      label: t("user.passwordRequirements.number", "At least one number"),
      met: hasNumber,
    },
  ];

  return (
    <div className="password-requirements">
      <p className="password-requirements__title">
        {t("user.passwordRequirements.title", "Password must contain:")}
      </p>
      <ul className="password-requirements__list">
        {reqs.map((req, index) => (
          <li
            key={index}
            className={`password-requirements__item ${
              req.met ? "is-met" : "is-missing"
            }`}
          >
            <Icon
              iconName={req.met ? "check-circle" : "circle"}
              className="password-requirements__icon"
            />
            <span>{req.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordRequirements;
